import { https } from './http';
import * as types from '../../mutation_types';

const state = {
    page:1,
    currentpage:5,
    search:'',
    company:'',
    supplier_from:'',
    supplier_to:'',
    date_from:'',
    date_to:'',
    status:'',
    partial_status:'',
    added_by:'',
    matnr:'',
    loading:false,
    data:{},

};
const getters = {
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    search:state=>state.search,
    company:state=>state.company,
    supplier_from:state=>state.supplier_from,
    supplier_to:state=>state.supplier_to,
    date_from:state=>state.date_from,
    date_to:state=>state.date_to,
    status:state=>state.status,
    partial_status:state=>state.partial_status,
    added_by:state=>state.added_by,
    matnr:state=>state.matnr,
    loading:state=>state.loading,
    data:state=>state.data,
};
const actions = {
    async fetchPurchaseReturns({commit}){
        commit(types.PURCHASE_RETURN_LOADING);
        let uri = `purchase-return-header?page=${state.page}&currentpage=${state.currentpage}&search=${state.search}&company=${state.company}&supplier_from=${state.supplier_from}
        &supplier_to=${state.supplier_to}&date_from=${state.date_from}&date_to=${state.date_to}&status=${state.status}&partial_status=${state.partial_status}&added_by=${state.added_by}
        &matnr=${state.matnr}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DATA,response.data);
            commit(types.PURCHASE_RETURN_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.PURCHASE_RETURN_LOADING);
        })
    }
};
const mutations = {
    [types.PURCHASE_RETURN_DATA](state,data){
        state.data = data;
    },
    [types.PURCHASE_RETURN_PAGE](state,data){
        state.page = data;
    },
    [types.PURCHASE_RETURN_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.PURCHASE_RETURN_LOADING](state){
        state.loading = !state.loading;
    },
    [types.PURCHASE_RETURN_SEARCH](state,data){
        state.search = data;
    },
    [types.PURCHASE_RETURN_COMPANY](state,data){
        state.company = data;
    },
    [types.PURCHASE_RETURN_SUPPLIER_FROM](state,data){
        state.supplier_from = data;
    },
    [types.PURCHASE_RETURN_SUPPLIER_TO](state,data){
        state.supplier_to = data;
    },
    [types.PURCHASE_RETURN_DATE_FROM](state,data){
        state.date_from = data;
    },
    [types.PURCHASE_RETURN_DATE_TO](state,data){
        state.date_to = data;
    },
    [types.PURCHASE_RETURN_STATUS](state,data){
        state.status = data;
    },
    [types.PURCHASE_RETURN_PARTIAL_STATUS](state,data){
        state.partial_status = data;
    },
    [types.PURCHASE_RETURN_ADDED_BY](state,data){
        state.added_by = data;
    },
    [types.PURCHASE_RETURN_MATNR](state,data){
        state.matnr = data;
    }
};
export {
    state,getters,actions,mutations
}